<div class="base-info mt-5 mb-5" *ngIf="data">
    <ngb-accordion #acc="ngbAccordion">
        <ngb-panel [title]="'employeeApplication_personData' | translate">
            <ng-template ngbPanelContent>
                <ul class="accordion-list">
                    <li>
                        <div class="data-value">
                            <label>{{'employeeApplication_lblFullName' | translate}}</label>
                            <div>{{data.FirstName}} {{data.LastName}}</div>
                        </div>

                        <div class="data-value">
                            <label>{{'employeeApplication_lblUpn' | translate}}</label>
                            <div>{{data.Upn}}</div>
                        </div>

                        <div class="data-value">
                            <label>{{'employeeApplication_lblEmail' | translate}}</label>
                            <div>{{data.Email}}</div>
                        </div>

                        <div class="data-value">
                            <label>{{'employeeApplication_lblStructure' | translate}}</label>
                            <div>{{data.StructureName}}</div>
                        </div>

                        <div class="data-value">
                            <label>{{'employeeApplication_lblWorkload' | translate}}</label>
                            <div>{{data.WorkloadName}}</div>
                        </div>
                    </li>
                </ul>
            </ng-template>
        </ngb-panel>
    </ngb-accordion>
</div>
